import script from "./Caap101Subtopics.vue?vue&type=script&setup=true&lang=js"
export * from "./Caap101Subtopics.vue?vue&type=script&setup=true&lang=js"

import "./Caap101Subtopics.vue?vue&type=style&index=0&id=6a7fd6b9&scoped=true&lang=css"

import exportComponent from "/builds/skilltech-ph/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6a7fd6b9"]])

export default __exports__